import SysAPI from "IZOX/ARCS/API/SysAPI";
import { GFunc, ReqX } from "IZOX/STATIC";

class User {

  static async Refresh(){
    let res = await ReqX.SendBE(SysAPI.RefreshAuth, {}, null, null);
    let {Success, payload} = res;
    if(Success){
      GFunc.Refresh(payload);
    }
  }

  static async GetSelfProfile(){
    let res = await ReqX.SendBE("/Web/User/GetSelfProfile", {}, null, null);
    return res;
  }

  static async SubmitProfile(formValue){
    let res = await ReqX.SendBE("/Web/User/SubmitProfile", {
      formValue
    }, null, null);
    return res;
  }

  static async ChangePassword(formValue){
    return await ReqX.SendBE(SysAPI.ChangePassword, {
      ...formValue,
      userID: GFunc.GetSELFUserID()
    });
  }

}

export default User;